export default "__VITE_ASSET__3Zt4MYX0__"